module.exports = __webpack_public_path__ + "exo-latin-700.734067b6563affe65beb.woff";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-700.woff
// module id = ../../../../typeface-exo/files/exo-latin-700.woff
// module chunks = styles